module.exports = __webpack_public_path__ + "img/bwtext.619ce3d0.svg";